import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import SubNavLink from './SubNavLink';
import { sireSubTabs } from '../helpers/tabNames';
import calculateTabUrl from '../helpers/calculateTabUrl';

const SubNav = ({ currentTab, url, hasWeatherbys }) => {
    const tab = currentTab ||
        (hasWeatherbys ? 'weatherbys-overview' : 'progeny');

    return (
        <div
            className={classNames(
                'pp-subTabs',
                sireSubTabs.stallionDetails.includes(tab) && 'pp-subTabs_weatherbys'
            )}
        >
            {Object.values(sireSubTabs)
                .find(subTabs => subTabs.includes(tab))
                .map((subTab, i) => (
                    <SubNavLink
                        url={url}
                        tabName={subTab}
                        tabUrl={calculateTabUrl(currentTab, subTab, i)}
                        key={subTab}
                    />
                ))}
        </div>
    );
};

SubNav.propTypes = {
    currentTab: PropTypes.string,
    url: PropTypes.string.isRequired,
    hasWeatherbys: PropTypes.bool.isRequired,
};

export default SubNav;



// WEBPACK FOOTER //
// ./src/js/shared/nav/components/SubNav.jsx